import { Skeleton } from "../Skeleton";

/** Encabezado de página (breadcrumbs opcionales, título, subtítulo) · mismas medidas que `PageHeader`. */
export function EncabezadoPaginaSkeleton({ conBreadcrumbs = false }: { conBreadcrumbs?: boolean }) {
  return (
    <div className="mb-6 flex flex-col gap-2" aria-hidden="true">
      {conBreadcrumbs && <Skeleton height={10} width={200} />}
      <Skeleton height={26} width={260} className="max-w-full" />
      <Skeleton height={14} width={420} className="max-w-full" />
    </div>
  );
}
